import campaignsApi from '@/api/v1/campaigns';
import cloneDeep from 'lodash.clonedeep';

export default {
  namespaced: true,

  state: {
    campaignsList: [],
    isProcessing: false,
  },

  mutations: {
    SET_CAMPAIGNS(state, campaigns) {
      state.campaignsList = campaigns;
    },

    ADD_CAMPAIGN(state, campaign) {
      state.campaignsList = [campaign, ...state.campaignsList];
    },

    UPDATE_CAMPAIGN(state, { id, data }) {
      const copiedCampaigns = cloneDeep(state.campaignsList);
      const campaignIndex = copiedCampaigns.findIndex((campaign) => campaign.id === id);
      copiedCampaigns[campaignIndex] = data;
      state.campaignsList = copiedCampaigns;
    },

    REMOVE_CAMPAIGN(state, id) {
      state.campaignsList = state.campaignsList.filter((campaign) => campaign.id !== id);
    },

    CHANGE_PROCESSING_STATUS(state, status) {
      state.isProcessing = status;
    },
  },

  actions: {
    fetchCampaigns({ commit }) {
      commit('CHANGE_PROCESSING_STATUS', true);

      campaignsApi.index()
        .then((response) => {
          commit('SET_CAMPAIGNS', response.data);
        })
        .finally(() => {
          commit('CHANGE_PROCESSING_STATUS', false);
        });
    },

    createCampaign({ commit, dispatch }, campaign) {
      commit('CHANGE_PROCESSING_STATUS', true);

      campaignsApi.create(campaign)
        .then((response) => {
          commit('ADD_CAMPAIGN', response.data);
          dispatch('snackbar/showSnackbar', {
            message: [`Utworzono kampanię ${campaign.name}`],
            type: 'success',
          }, { root: true });
        })
        .finally(() => {
          commit('CHANGE_PROCESSING_STATUS', false);
        });
    },

    updateCampaign({ commit, dispatch }, campaign) {
      commit('CHANGE_PROCESSING_STATUS', true);
      const { id, ...campaignData } = campaign;
      campaignsApi.update(id, campaignData)
        .then((response) => {
          commit('UPDATE_CAMPAIGN', { id, data: response.data });
          dispatch('snackbar/showSnackbar', {
            message: [`Zaktualizowano kampanię ${campaign.name}`],
            type: 'success',
          }, { root: true });
        })
        .finally(() => {
          commit('CHANGE_PROCESSING_STATUS', false);
        });
      },

      deleteCampaign({ commit, dispatch }, campaign) {
        commit('CHANGE_PROCESSING_STATUS', true);

        campaignsApi.delete(campaign.id)
          .then(() => {
            commit('REMOVE_CAMPAIGN', campaign.id);
            dispatch('snackbar/showSnackbar', {
              message: [`Poprawnie usunięto kampanię ${campaign.name}`],
              type: 'success',
            }, { root: true });
          })
          .finally(() => {
            commit('CHANGE_PROCESSING_STATUS', false);
          });
    },
  },
};
